import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'payment.order.details.section.heading': {
    id: 'payment.order.details.section.heading',
    defaultMessage: 'Order Details',
    description: 'Order Details Section Heading',
  },
  'payment.order.details.section.mode.verified': {
    id: 'payment.order.details.section.mode.verified',
    defaultMessage:
      'The above total includes any applicable taxes. After you complete your order you will be automatically enrolled in the verified track of the course.',
    description:
      'A paragraph explaining what will happen after the user pays for the verified track of a course.',
  },
  'payment.order.details.section.mode.professional': {
    id: 'payment.order.details.section.mode.professional',
    defaultMessage:
      'After you complete your order you will be automatically enrolled in the course.',
    description:
      'A paragraph explaining what will happen after the user pays for a course.',
  },
  'payment.order.details.section.mode.credit': {
    id: 'payment.order.details.section.mode.credit',
    defaultMessage:
      'After you complete your order you will receive credit for your course.',
    description:
      'A paragraph explaining what will happen after the user pays for a course they will receive credit for.',
  },
  'payment.order.details.section.mode.program': {
    id: 'payment.order.details.section.mode.program',
    defaultMessage:
      'After you complete your order you will be able to select course dates from your dashboard.',
    description:
      'A paragraph explaining what will happen after the user pays for an entire program.',
  },
});
